module.exports = __webpack_public_path__ + "static/media/Android-icon.7c1bb903.png";